'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const InfoCircleIcon = require('dibs-vg/dist/react/info-circle');

const QuickViewButton = React.createClass({

    propTypes: {
        onClick: PropTypes.func.isRequired
    },

    render() {
        return (
            <a onClick={this.props.onClick} className="quick-view-button">
                <InfoCircleIcon />
            </a>
        );
    }

});

module.exports = QuickViewButton;



// WEBPACK FOOTER //
// ./assets/js/components/ProductQuickView/QuickViewButton.jsx